import { render } from "./RemaindStock.vue?vue&type=template&id=1fcb5200&scoped=true"
import script from "./RemaindStock.vue?vue&type=script&lang=js"
export * from "./RemaindStock.vue?vue&type=script&lang=js"

import "./RemaindStock.vue?vue&type=style&index=0&id=1fcb5200&scoped=true&lang=css"
import "./RemaindStock.vue?vue&type=style&index=1&id=1fcb5200&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\INVENTORY BCK\\inventoryfe_bck\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcb5200"]])

export default __exports__